'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setContextMenu;

var _constants = require('../constants');

function setContextMenu(playerId, contextMenuOpen) {
  return {
    type: _constants.SET_CONTEXT_MENU,
    playerId: playerId,
    contextMenuOpen: contextMenuOpen
  };
}
module.exports = exports['default'];